import React from "react";
import { Col, Row, Tooltip } from "antd";

const AverageTurnoverTime = (
  <div className="dashboardTooltip">
    <p>
      The average time it takes to complete unit turns at properties you can
      view.
    </p>
  </div>
);
const UnitsPostedOnline = (
  <div className="dashboardTooltip">
    <p>
      This represents the number of units posted on your website and/or any
      Internet Listing Service sites.
    </p>
  </div>
);
const LeasingActivity = () => {
  return (
    <div className="LeasingActivity">
      <div className="dshbrd_acrdn">
        <p className="alert alert-info">
          <span className="badge">NEW</span> You reviewed 72 screening reports last
          month. Confirm applicants' ability to pay with{" "}
          <a
            className="js-leasing-activity-income-verification-link"
            target="_blank"
            rel="noopener noreferrer"
            href="/screenings/income_verification_awareness"
          >
            Income Verification.
          </a>
        </p>
        <Row>
          <Col span={12}>
            <p>Guest Cards</p>
            <p>
              No <a href="/"> guest cards</a> received.
            </p>
          </Col>
          <Col span={12}>
            <p>Rental Applications</p>
            <p>
              No <a href="/"> rental applications</a> received.
            </p>
          </Col>
        </Row>
        <p>Online Leases</p>
        <Row>
          <Col span={8}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">Out for Signing</h2>
            </div>
          </Col>
          <Col span={7} offset={1}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">
                Ready to Countersign
              </h2>
            </div>
          </Col>
          <Col span={7} offset={1}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">Fully Executed</h2>
            </div>
          </Col>
        </Row>

        <p>Upcoming Lease Expirations</p>
        <Row>
          <Col span={12}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">
                Expiring This Month
              </h2>
            </div>
          </Col>
          <Col span={11} offset={1}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">
                Expiring Next Month
              </h2>
            </div>
          </Col>
        </Row>

        <p>Current Statistics</p>
        <Row>
          <Col span={12}>
            <div className="collected">
              <span className="widget-info-box__datum">0</span>
              <h2 className="widget-info-box__description">
                Units Posted Online
              </h2>
              <Tooltip
                placement="bottom"
                title={UnitsPostedOnline}
                trigger={["click"]}
                color={["#fff"]}
              >
                <i className="fa-sharp fa-solid fa-circle-question"></i>
              </Tooltip>
            </div>
          </Col>
          <Col span={11} offset={1}>
            <div className="collected">
              <span className="widget-info-box__datum">No Data</span>
              <h2 className="widget-info-box__description">
                Average Turnover Time
              </h2>
              <Tooltip
                placement="bottom"
                title={AverageTurnoverTime}
                trigger={["click"]}
                color={["#fff"]}
              >
                <i className="fa-sharp fa-solid fa-circle-question"></i>
              </Tooltip>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LeasingActivity;
